import React from "react";

import {close} from "../../icons";
import Modal from "../../common/modal/Modal";
import ModalHeader from "../../common/modal/ModalHeader";
import ModalBody from "../../common/modal/ModalBody";
import ModalFooter from "../../common/modal/ModalFooter";

type Props = {
    isOpen: boolean,
    toggleModal: React.MouseEventHandler<HTMLButtonElement>,
    uploadLogo: React.ChangeEventHandler<HTMLInputElement>,
    logo: {
        url: string,
        name: string
    } | null
}

const UploadLogoModal = (props: Props) => {
	const {isOpen, toggleModal, uploadLogo, logo} = props;
    return (
        <Modal isOpen={isOpen} className="upload-img-modal">
            <ModalHeader>
                <h5 className="modal-title">Upload your brand logo</h5>
                <button type="button" className="btn btn-link" aria-label="Close" onClick={toggleModal}>
                    <span aria-hidden="true">{close}</span>
                </button>
            </ModalHeader>
            <ModalBody>
                <div className="custom-file mb-3">
                    <input
                        type="file"
                        className="custom-file-input"
                        name="filename"
                        onChange={uploadLogo}
                    />
                    <label className="custom-file-label" htmlFor="customFile">
                        {logo ? logo.name : "Choose file"}
                    </label>
					<small className="d-inline-block ml-1">Valid extensions: jpg, jpeg, png, svg</small>
                </div>
                <div className="img-preview">
                    {logo && <img src={logo.url} alt="Logo"/>}
                </div>
            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn btn-outline-danger" onClick={toggleModal}>Close</button>
            </ModalFooter>
        </Modal>
    );
};

export default UploadLogoModal;
